import { Report1918 } from "../../../components/borrowSystem/Report/Report1918";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1918Container() {
  const titleName =
    " ทะเบียนข้อมูลสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน ตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1918 />
      <Footer />
    </div>
  );
}
